import React from 'react';

const ProdottiIcon = (props) => {
  const fill = props ? props.color : '#294C76';
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1.99057 1.99057C-0.663523 4.64466 -0.663523 8.9478 1.99057 11.6019L4.55391 14.1652L5.0495 14.0698C5.04919 14.0698 5.04956 14.0698 5.05049 14.0696L5.06435 14.0666C5.07872 14.0634 5.10332 14.0577 5.13754 14.0491C5.20599 14.0318 5.31287 14.0027 5.45346 13.9578C5.73465 13.868 6.1504 13.7153 6.66292 13.4683C7.68709 12.9747 9.10053 12.1037 10.6019 10.6023C12.1032 9.10101 12.9744 7.68744 13.468 6.66312C13.7151 6.15053 13.8679 5.73472 13.9578 5.45347C14.0027 5.31286 14.0318 5.20594 14.0491 5.13748C14.0577 5.10325 14.0634 5.07865 14.0666 5.06426L14.0696 5.05043C14.0698 5.04952 14.0699 5.04909 14.0698 5.0494L14.1653 4.55397L11.6019 1.99057C8.9478 -0.663523 4.64466 -0.663523 1.99057 1.99057Z"
        fill={fill}
      />
      <path
        d="M15.4187 5.80734C15.4087 5.83998 15.398 5.87417 15.3866 5.90986C15.2772 6.25257 15.099 6.73396 14.8193 7.31437C14.2594 8.47606 13.2939 10.0316 11.6625 11.663C10.0312 13.2943 8.47569 14.2598 7.31411 14.8195C6.73375 15.0992 6.2524 15.2773 5.90973 15.3867C5.8741 15.3981 5.83996 15.4088 5.80737 15.4187L8.39811 18.0094C11.0522 20.6635 15.3553 20.6635 18.0094 18.0094C20.6635 15.3553 20.6635 11.0522 18.0094 8.39811L15.4187 5.80734Z"
        fill={fill}
      />
    </svg>
  );
};

export default ProdottiIcon;
